import axios from "axios";

/*------------------设置header--------------*/
//请求数据类型
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["lang"] = localStorage.getItem("lang")
    ? localStorage.getItem("lang")
    : "zh_CN";

/*-------------创建axios实例，并且配置参数---------------*/
const instance = axios.create({
    withCredentials: true, //携带cookie?
});

//在需要跳转的地方使用
//router.history.push("/manage");

/*--------------发出请求拦截---------------*/
instance.interceptors.request.use(
    (config) => {
        //默认给请求header添加token
        config.headers["lang"] = localStorage.getItem("lang")
            ? localStorage.getItem("lang")
            : "zh_CN";

        //发送时显示加载动画
        return config;
    },
    (error) => {
        //如果发送错误，隐藏动画，并且返回reject

        return Promise.reject(error);
    }
);
/*--------------接收拦截---------------*/
instance.interceptors.response.use(
    (response) => {
        //接收数据即隐藏加载动画

        /**
         *判断各种通用的错误code，并给出对应的行为，并返回reject
         * 比如：返回未登陆，则强制退出到登陆页
         **/

        return response.data;
    },
    () => {
        //网络错误等原因导致的错误，隐藏动画，显示系统异常，并返回reject

        return Promise.reject({
            messageCode: "sysError",
        });
    }
);

export default instance;



// WEBPACK FOOTER //
// ./src/http/index.js